var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _vm.updateGuide ? _c("div", { staticClass: "updateGuide" }) : _vm._e(),
      _c("NewComments", {
        attrs: { messageType: _vm.messageType, siteId: _vm.siteId },
      }),
      _c(
        "div",
        { staticClass: "wl-content-container content-with-comments" },
        [
          [
            _c("div", { staticClass: "tab-row" }, [
              _c("ul", { staticClass: "tab-cls" }, [
                _c(
                  "li",
                  {
                    class: _vm.activeTab === "0" ? "active" : "",
                    on: {
                      click: function ($event) {
                        return _vm.activeChange("0")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("PAGE_EXCHANGE_TAB1")) +
                        "\n                        "
                    ),
                    _c("GuidanceTooltip", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.getUser.userType == "1",
                          expression: "getUser.userType == '1'",
                        },
                      ],
                      staticClass: "GuidanceTooltip",
                      attrs: {
                        backgroundColor: "none",
                        yellowIcon: "",
                        content: _vm.$t("exchange_tip_kp"),
                        size: "17",
                        iconSize: "15",
                        jumpLink: _vm.$t("exchange_tip_link_kp"),
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.enableITU || _vm.activeTab == "3",
                        expression: "enableITU || activeTab == '3'",
                      },
                    ],
                    class: [
                      _vm.activeTab === "3" ? "active" : "",
                      _vm.updateGuide && _vm.updateGuideStep === 2
                        ? "updateGuideTab"
                        : "",
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.activeChange("3")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("PAGE_EXCHANGE_TAB4")) +
                        "\n                        "
                    ),
                    _c("GuidanceTooltip", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.getUser.userType == "1",
                          expression: "getUser.userType == '1'",
                        },
                      ],
                      staticClass: "GuidanceTooltip",
                      attrs: {
                        backgroundColor: "none",
                        yellowIcon: "",
                        content: _vm.$t("ITU_tip"),
                        size: "17",
                        iconSize: "15",
                        jumpLink: _vm.$t("ITU_tip_link"),
                      },
                    }),
                    _vm.updateGuide && _vm.updateGuideStep === 2
                      ? _c(
                          "div",
                          { staticClass: "updateGuideTip" },
                          [
                            _c("div", { staticClass: "margin-bottom-10" }, [
                              _vm._v("2/2"),
                            ]),
                            _c("div", { staticClass: "margin-bottom-10" }, [
                              _vm._v(_vm._s(_vm.$t("ITUnderstanding"))),
                            ]),
                            _c(
                              "el-button",
                              {
                                staticClass: "guide-btn",
                                on: { click: _vm.gotItClick },
                              },
                              [_vm._v(_vm._s(_vm.$t("gotIt")))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "btn" }, [
                _c(
                  "span",
                  {
                    class: [
                      "clear-filter",
                      _vm.clearFilterActive ? "clear-filter-active" : "",
                    ],
                    on: { click: _vm.clearAll },
                  },
                  [
                    _c("img", {
                      staticClass: "table-setting-icon",
                      attrs: { src: require("@/assets/img/icon-screen.svg") },
                    }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("clear_filter")) +
                        "\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm.activeTab === "0"
              ? _c("div", { staticClass: "bar-row" }, [
                  _c(
                    "div",
                    { staticClass: "left" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "wl-green",
                          attrs: {
                            disabled:
                              !_vm.hasPermission("download") ||
                              (_vm.chooseable && !!_vm.multiChoose.mode),
                            icon: "el-icon-download",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toogleMultiSelect("download")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("BATCH_DOWNLOAD")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm.activeTab === "0" && _vm.isKpmgUser()
                        ? _c(
                            "el-button",
                            {
                              staticClass: "wl-green svg-btn",
                              attrs: {
                                disabled:
                                  _vm.chooseable && !!_vm.multiChoose.mode,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toogleMultiSelect("delete")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "btn-icon",
                                attrs: {
                                  src: require("@/assets/img/icon-batchdeletion.svg"),
                                  width: "100%",
                                },
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("patch_delete")) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "wl-search-bar" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "dark", placement: "bottom" },
                        },
                        [
                          _c("div", {
                            staticStyle: { width: "590px" },
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("JOINT_WORKING_ADD_TIPS")
                              ),
                            },
                            slot: "content",
                          }),
                          _c(
                            "span",
                            [
                              _vm.isKpmgUser()
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "wl-green mgr10",
                                      attrs: {
                                        icon: "el-icon-plus",
                                        disabled: !(
                                          _vm.kpRoleBind &&
                                          _vm.kpRoleBind.length > 0
                                        ),
                                      },
                                      on: { click: _vm.toggleAddVisible },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("COMMON_ADD")) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.isKpmgUser()
                        ? _c(
                            "el-button",
                            {
                              staticClass: "wl-green",
                              attrs: {
                                disabled:
                                  _vm.chooseable && !!_vm.multiChoose.mode,
                                icon: "el-icon-message",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toogleMultiSelect("email")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      `PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB${_vm.activeTab}`
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "wl-green svg-btn",
                          attrs: { disabled: !_vm.hasPermission("download") },
                          on: { click: _vm.exportList },
                        },
                        [
                          _c("img", {
                            staticClass: "btn-icon",
                            attrs: {
                              src: require("@/assets/img/icon-export.svg"),
                              width: "100%",
                            },
                          }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("Export_exchange_Items")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "wl-green svg-btn",
                          attrs: {
                            disabled:
                              !_vm.hasPermission("download") ||
                              (_vm.chooseable && !!_vm.multiChoose.mode),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toogleMultiSelect("export")
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "btn-icon",
                            attrs: {
                              src: require("@/assets/img/icon-export.svg"),
                              width: "100%",
                            },
                          }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("BATCH_export")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.activeTab === "3"
              ? _c("ITAIndex", {
                  ref: "ITA",
                  staticClass: "ITA-container",
                  attrs: {
                    entityData: _vm.entityData,
                    toogleClearFilterActive: _vm.toogleItuClearFilterActive,
                  },
                })
              : _vm._e(),
            _vm.activeTab === "0"
              ? _c(
                  "div",
                  {
                    class: [
                      "table-container-wrapper",
                      _vm.chooseable ? "show-table-bottom-operate" : "",
                    ],
                  },
                  [
                    _vm.updateGuide && _vm.updateGuideStep === 1
                      ? _c(
                          "div",
                          {
                            staticClass: "updateGuideTitle",
                            style: {
                              height: `${_vm.updateGuideTitleHeight}px`,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "updateGuideTip",
                                style: {
                                  top: `${_vm.updateGuideTitleHeight + 10}px`,
                                },
                              },
                              [
                                _c("div", { staticClass: "margin-bottom-10" }, [
                                  _vm._v(_vm._s(_vm.enableITU ? "1/2" : "1/1")),
                                ]),
                                _c("div", { staticClass: "margin-bottom-10" }, [
                                  _vm._v(_vm._s(_vm.$t("filterFunction"))),
                                ]),
                                _vm.enableITU
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "guide-btn",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.nextClick.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("next")))]
                                    )
                                  : _c(
                                      "el-button",
                                      {
                                        staticClass: "guide-btn",
                                        on: { click: _vm.gotItClick },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("gotIt")))]
                                    ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        ref: "exchangeTable",
                        staticClass: "exchange-table",
                        attrs: {
                          height: "100%",
                          data: _vm.data,
                          border: "",
                          "header-cell-class-name": _vm.updateGuideClass,
                          stripe: "",
                        },
                        on: {
                          "select-all": (e) => _vm.handleSelectAll(e, _vm.data),
                          select: _vm.handleSelect,
                        },
                      },
                      [
                        _vm.chooseable
                          ? _c("el-table-column", {
                              attrs: {
                                align: "center",
                                type: "selection",
                                width: "50",
                              },
                            })
                          : _vm._e(),
                        _c("el-table-column", {
                          key: 1,
                          attrs: {
                            prop: "entityName",
                            width: "400",
                            "show-overflow-tooltip": "",
                            label: _vm.$t("TABLE_HEAD_EntityList"),
                          },
                        }),
                        _c("el-table-column", {
                          key: 2,
                          attrs: {
                            prop: "category",
                            "min-width": "150",
                            align: "left",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "header-with-popup" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t("TABLE_HEAD_Category")
                                            ) +
                                            "\n                                "
                                        ),
                                        _c("MultiSelectPopver", {
                                          attrs: {
                                            hidePopperSearch:
                                              _vm.hidePopperSearch,
                                            value: _vm.searchForm.category,
                                            labelKey: "label",
                                            valueKey: "value",
                                            inputFilterKey: ["label", "value"],
                                            options: _vm.categoryOptions,
                                          },
                                          on: {
                                            "update:value": function ($event) {
                                              return _vm.$set(
                                                _vm.searchForm,
                                                "category",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2208745996
                          ),
                        }),
                        _c("el-table-column", {
                          key: 6,
                          attrs: {
                            prop: "fileList",
                            width: "200",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "header-with-popup" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t(
                                                "TABLE_HEADER_fileNameList"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "bottom",
                                              trigger: "click",
                                              "visible-arrow": false,
                                            },
                                            on: { hide: _vm.hidePopperSearch },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "reference",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "th-filter-down",
                                                        },
                                                        [
                                                          _c("i", {
                                                            class: [
                                                              "el-icon-arrow-down",
                                                              _vm.searchForm
                                                                .searchContent
                                                                ? "el-icon-arrow-down-active"
                                                                : "",
                                                            ],
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1258752357
                                            ),
                                          },
                                          [
                                            [
                                              _c("el-input", {
                                                staticClass:
                                                  "input-with-select",
                                                attrs: {
                                                  size: "medium",
                                                  placeholder:
                                                    _vm.$t("fileNameKeyword"),
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.searchForm
                                                      .searchContent,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.searchForm,
                                                      "searchContent",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "searchForm.searchContent",
                                                },
                                              }),
                                            ],
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.fileList &&
                                    scope.row.fileList.length > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "file-number-hint",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toogleFileDetailVisible(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  scope.row.fileList.length
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            342495728
                          ),
                        }),
                        _c("el-table-column", {
                          key: 7,
                          attrs: {
                            align: "center",
                            width: "150",
                            label: _vm.$t("COMMON_UPLOAD"),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    !_vm.isIE
                                      ? _c("i", {
                                          class: [
                                            "el-icon-upload",
                                            !_vm.hasPermission("upload")
                                              ? "wl-icon-messageBoardNull"
                                              : "wl-icon-messageBoard",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.toogleUploadVisible(
                                                scope.row
                                              )
                                            },
                                          },
                                        })
                                      : _c(
                                          "el-button",
                                          {
                                            class: [
                                              "el-icon-upload",
                                              !_vm.hasPermission("upload")
                                                ? "upload-forbid"
                                                : "wl-green",
                                            ],
                                            attrs: {
                                              size: "mini",
                                              disabled:
                                                !_vm.hasPermission("upload"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toogleUploadVisible(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("COMMON_UPLOAD"))
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3074132769
                          ),
                        }),
                        _c("el-table-column", {
                          key: 8,
                          attrs: {
                            width: "180",
                            align: "center",
                            label: _vm.$t("TABLE_HEAD_COMMENTS"),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "header-with-popup" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t("TABLE_HEAD_COMMENTS")
                                            ) +
                                            "\n                                "
                                        ),
                                        _c("DatePickerPopover", {
                                          attrs: {
                                            value: _vm.searchForm.commentDate,
                                            hidePopperSearch:
                                              _vm.hidePopperSearch,
                                          },
                                          on: {
                                            "update:value": function ($event) {
                                              return _vm.$set(
                                                _vm.searchForm,
                                                "commentDate",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex item-center justify-center",
                                      },
                                      [
                                        _c("i", {
                                          class: [
                                            scope.row.todayCommentCount > 0
                                              ? "wl-icon-messageBoard"
                                              : "wl-icon-messageBoardNull",
                                            "el-icon-s-comment",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.toogleMessageBoardVisible(
                                                scope.row
                                              )
                                            },
                                          },
                                        }),
                                        scope.row.todayCommentCount
                                          ? _c("span", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "message-today",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row
                                                        .todayCommentCount
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("span", [_vm._v("/")]),
                                            ])
                                          : _vm._e(),
                                        scope.row.messageNum > 0
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.messageNum)
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            869241730
                          ),
                        }),
                        _vm.isKpmgUser()
                          ? _c("el-table-column", {
                              key: 9,
                              attrs: {
                                width: "170",
                                align: "center",
                                label: _vm.$t("TABLE_HEADER_Action"),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-edit-outline wl-icon-edit",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEdit(scope.row)
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-delete wl-icon-delete",
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDelete(scope.row)
                                              },
                                            },
                                          }),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2636650388
                              ),
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.chooseable && _vm.activeTab === "0"
              ? _c(
                  "div",
                  { staticClass: "footer-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "cancel-btn",
                        attrs: { disabled: !_vm.chooseable },
                        on: { click: _vm.cancelChoose },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("btn_cancel")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm.chooseable && _vm.multiChoose.mode == "download"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.hasSelectedList.length == 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.tooglebatchDownLoad("download")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("COMMON_DOWNLOAD")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.isKpmgUser() &&
                    _vm.chooseable &&
                    _vm.multiChoose.mode == "email"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.hasSelectedList.length == 0,
                            },
                            on: { click: _vm.toogleEmailVisible },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    `PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB${_vm.activeTab}`
                                  )
                                ) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.isKpmgUser() &&
                    _vm.chooseable &&
                    _vm.multiChoose.mode == "delete"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.hasSelectedList.length == 0,
                            },
                            on: { click: _vm.onBatchDelete },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("COMMON_DELETE")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.chooseable && _vm.multiChoose.mode == "export"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.hasSelectedList.length == 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.tooglebatchDownLoad("export")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("BATCH_export")) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.activeTab === "0"
              ? _c(
                  "el-pagination",
                  {
                    staticClass: "wl-pagination",
                    attrs: {
                      "current-page": _vm.pagination.pageNum,
                      "page-size": _vm.pagination.pageSize,
                      layout: "prev, pager, next, slot, total",
                      total: _vm.pagination.total,
                    },
                    on: {
                      "current-change": _vm.onCurrentPageChange,
                      "size-change": _vm.onSizeChange,
                    },
                  },
                  [
                    _c(
                      "span",
                      [
                        _c(
                          "el-select",
                          {
                            on: { change: _vm.onSizeChange },
                            model: {
                              value: _vm.pagination.pageSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.pagination, "pageSize", $$v)
                              },
                              expression: "pagination.pageSize",
                            },
                          },
                          _vm._l(_vm.pageOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ],
        ],
        2
      ),
      _vm.addVisible
        ? _c("exchange-add", {
            attrs: {
              saveLoading: _vm.btnLoading,
              initData: _vm.initData,
              onCancel: _vm.toggleAddVisible,
              onAdd: _vm.saveEntityCategory,
            },
          })
        : _vm._e(),
      _vm.addVisibleEmail
        ? _c("exchange-email", {
            attrs: {
              saveLoading: _vm.emailBtnLoading,
              onCancel: _vm.toogleEmailVisible,
              onAdd: _vm.sendEmail,
            },
          })
        : _vm._e(),
      _vm.uploadVisible
        ? _c("upload", {
            attrs: {
              initData: _vm.rowData,
              onCancel: _vm.closeUploadVisble,
              onAdd: _vm.uploadSuccess,
            },
          })
        : _vm._e(),
      _vm.messageBoardVisible
        ? _c("messageBoard", {
            attrs: {
              initData: _vm.rowData,
              onCancel: _vm.toogleMessageBoardVisible,
              onAdd: _vm.getTableList,
              messageType: _vm.messageType,
              siteId: _vm.siteId,
            },
          })
        : _vm._e(),
      _vm.fileDetailVisbile
        ? _c("file-detail", {
            attrs: {
              id: _vm.rowData.id,
              tableData: _vm.rowData.fileList,
              curUserName: _vm.curUserName,
              downloadAble: _vm.downloadAble,
              onCancel: _vm.toogleFileDetailVisible,
            },
            on: { "on-file-download": _vm.downloadFileDetail },
          })
        : _vm._e(),
      _c("file-confirm-modal", {
        ref: "FileConfirmModal",
        attrs: {
          fileDownloading: _vm.fileDownloading,
          groupList: _vm.hasSelectedList,
          curUserName: _vm.curUserName,
          downloadAble: _vm.downloadAble,
          mode: _vm.downloadDialogMode,
        },
        on: {
          ok: _vm.downloadMultipleFiles,
          "on-file-download": _vm.downloadFileDetail,
          updateMultipleSelection: _vm.updateMultipleSelection,
        },
      }),
      _c("entity", {
        ref: "entityRef",
        attrs: { onAdd: _vm.onDrawClick, entityData: _vm.entityData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }